export const poa = [

      {
        "anio": "2025",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../pdf/POA/2025/POA2025_1.pdf"
            },
             {
                "trimestre": "Segundo Trimestre",
                "url": "../pdf/POA/2025/POA2025_2.pdf"
            },
              {
                "trimestre": "Tercer Trimestre",
                "url": "../pdf/POA/2025/POA2025_3.pdf"
            },

             {
                "trimestre": "Cuarto Trimestre",
                "url": "../pdf/POA/2025/POA2025_4.pdf"
            },

        ]
    },
   
    {
        "anio": "2024",
        "trimestres": [
            {
                "trimestre": "Primer Trimestre",
                "url": "../pdf/POA/2024/POA2024_1.pdf"
            },

            {
                "trimestre": "Segundo Trimestre",
                "url": "../pdf/POA/2024/POA2024_2.pdf"
            },
            {
                "trimestre": "Tercer Trimestre",
                "url": "../pdf/POA/2024/POA2024_3.pdf"
            },
            {
                "trimestre": "Cuarto Trimestre",
                "url": "../pdf/POA/2024/POA2024_4.pdf"
            },
          
          
        ]
    },
   
    

]